<template>
  <div>
    <h6 class="mb-3">{{ this.label }}</h6>
    <PieChart
      :chart-data="chartData"
      @rowClick="handleClick"
      @chartClick="handleClick"
    />
  </div>
</template>

<script>
  import _ from 'lodash';
  import { INSPECTION_ITEM_RESPONSE } from '@/_legacy/constants';
  import PieChart from '@/_legacy/views/Analytics/components/PieChart.vue';
  import { pushRoute } from '@/ui/helpers/uiHelper';

  export default {
    name: 'Checkbox',
    components: { PieChart },
    props: {
      questionSet: {
        type: Object,
        default: () => {
        },
      },
      label: {
        type: String,
        default: '',
      },
      uuid: {
        type: String,
        default: '',
      },
    },

    computed: {
      questions() {
        return _.sortBy(this.questionSet.questions, ['response'], ['desc']);
      },
      marked() {
        return _.sumBy(_.filter(this.questions, 'response'), 'count');
      },
      notMarked() {
        return _.sumBy(_.filter(this.questions, question => !question.response), 'count');
      },
      chartData() {
        return {
          series: [
            {
              className: 'green',
              label: this.$t('Checkbox marked'),
              meta: {
                response: 1,
                uuid: this.uuid,
              },
              value: this.marked,
            },
            {
              className: 'red',
              label: this.$t('Checkbox not marked'),
              meta: {
                response: 0,
                uuid: this.uuid,
                type: INSPECTION_ITEM_RESPONSE.CHECKBOX,
              },
              value: this.notMarked,
            },
          ],
        };
      },
    },

    methods: {
      handleClick(meta) {
        pushRoute({
          name: 'analyticsSummaryChecklistsExplain',
          params: { id: this.$route.params.id },
          query: {
            ...meta.uuid !== undefined && { uuid: meta.uuid },
            ...meta.response !== undefined && { response: meta.response },
            ...meta.type !== undefined && { type: meta.type },
          },
        });
      },
    },
  };
</script>
